import React from 'react';
import { ButtonLink } from './Button';
import { BrandSeal, Halo } from './Decor';
import { WHATSAPP_URL } from '../data/site';
export function FinalCta() {
  return <section aria-labelledby="cierre-titulo" className="relative overflow-hidden bg-gradient-to-b from-lavender-50 to-cream" data-id="element-31" data-mp="vhivm2qc9gay">
      <Halo className="left-1/2 top-6 h-[26rem] w-[26rem] -translate-x-1/2 sm:h-[34rem] sm:w-[34rem]" data-id="element-32" data-mp="15carn249vv3m" />
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-10 hidden h-[22rem] w-[22rem] -translate-x-1/2 rounded-full border border-lavender-200/70 lg:block" data-id="element-33" data-mp="1jc3fmpoezx7w" />

      <div className="relative mx-auto max-w-content px-5 py-16 sm:px-8 sm:py-24 lg:py-32" data-id="element-34" data-mp="1t1mznynv5x4c">
        <div className="mx-auto max-w-2xl text-center" data-id="element-35" data-mp="1o4wmbj3g1fmm">
          <BrandSeal className="mx-auto mb-7 hidden h-20 w-20 sm:block" data-id="element-36" data-mp="223mimwifvb9x" />

          <h2 id="cierre-titulo" className="font-display text-[1.8rem] leading-[1.12] text-plum-900 sm:text-[2.6rem] lg:text-[3.1rem]" data-id="element-37" data-mp="221jteep41m69">
            Tu idea merece una estructura para crecer.
          </h2>
          <p className="mx-auto mt-4 max-w-md text-[1rem] leading-relaxed text-muted sm:mt-5 sm:text-[1.0625rem]" data-id="element-38" data-mp="s45uyad7htxx">
            Empieza por lo correcto. En Inkova te ayudamos a construir lo que sigue.
          </p>
          <ButtonLink size="lg" analyticsId="final_cta_whatsapp" href={WHATSAPP_URL} className="mt-7 w-full sm:mt-9 sm:w-auto" data-id="element-39" data-mp="123521oibphit">
            Quiero comenzar mi negocio
          </ButtonLink>
        </div>
      </div>
    </section>;
}